<template>
  <div>
    <ProducaoBar
      :is-midias-moderacao="true"
      :num_coluna_telao="num_coluna_telao"
      :changeColuna="changeColuna"
      :cod_pasta="cod_pasta"
      :selected-tab-number="0"
    />

    <v-row class="ma-0 pa-5">
      <v-col>
        <ColaboracoesAprovadas
          v-if="cod_producao && colaboracoes"
          :data="colaboracoes"
          :diff="diff"
          :showModal="showModal"
          :closeModal="closeModal"
          :cod_producao="Number(cod_producao)"
          @changeFavorita="changeFavorita"
          :currentAprovadasPage="currentAprovadasPage"
          :changeFlags="changeFlags"
          :num_coluna_telao="num_coluna_telao"
        />

        <v-pagination
          v-if="cod_producao && colaboracoes && !flg_exibida && !flg_favorita && !isPastaAtiva"
          class="mt-5"
          v-model="page"
          :length="colaboracoes?.colaboracoes_recebidas?.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
          :cod_pasta="cod_pasta"
        />

        <v-pagination
          v-if="cod_producao && colaboracoes && !flg_exibida && flg_favorita"
          class="mt-5"
          v-model="page"
          :length="colaboracoes?.colaboracoes_favoritas?.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
          :cod_pasta="cod_pasta"
        />

        <v-pagination
          v-if="cod_producao && colaboracoes && flg_exibida"
          class="mt-5"
          v-model="page"
          :length="colaboracoes?.colaboracoes_exibidas?.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
          :cod_pasta="cod_pasta"
        />

        <v-pagination
          v-if="cod_producao && colaboracoes && isPastaAtiva"
          class="mt-5"
          v-model="page"
          :length="colaboracoes?.colaboracoes_em_pasta?.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
          :cod_pasta="cod_pasta"
        />
      </v-col>
      <v-col>
        <ColaboracoesModeradas
          v-if="cod_producao && colaboracoesModeradas"
          :dataModerada="colaboracoesModeradas"
          :getModeradaData="getColunaColaboracoesModerada"
          :num_coluna_telao="num_coluna_telao"
          :cod_producao="Number(cod_producao)"
          :changeColuna="changeColuna"
          :pageModerada="pageModerada"
          :producaoUsesTarja="producaoUsesTarja"
          :coluna_selecionada="coluna_selecionada"
          :changeColunaSelecionada="changeColunaSelecionada"
          :cod_pasta="cod_pasta"
        />

        <v-pagination
          v-if="cod_producao && colaboracoesModeradas"
          class="mt-5"
          v-model="pageModerada"
          :length="colaboracoesModeradas[num_coluna_telao]?.totalPages || 1"
          @input="handleModeradasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
    </v-row>

    <ModalEditarColaboracao
      v-if="isModalVisible"
      @close="closeModal"
      :modalData="modalData"
    />
    <NotificacaoColaboracoes v-if="showToastNotification" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ColaboracoesAprovadas from "../components/Colaboracoes/ColaboracoesAprovadas";
import ColaboracoesModeradas from "../components/Colaboracoes/ColaboracoesModeradas";
import ModalEditarColaboracao from "../components/Modal/Colaboracao/ModalEditarColaboracao";
import ProducaoBar from "@/components/Producao/ProducaoBar.vue";
import { POSITION } from "vue-toastification";
import NotificacaoColaboracoes from "@/components/Toast/NotificacaoColaboracoes.vue";
export default {
  name: "ColaboracoesView",
  components: {
    ColaboracoesAprovadas,
    ColaboracoesModeradas,
    ModalEditarColaboracao,
    ProducaoBar,
    NotificacaoColaboracoes,
  },
  data() {
    return {
      showToastNotification: false,
      isDark: this.$vuetify.theme.dark,
      num_coluna_telao: 1,
      paginasExibidas: 9,
      idColaboracaoTarja: null,
      cod_producao: null,
      isModalVisible: false,
      producaoUsesTarja: this.$store.state.producoes.selectedProducao?.settings?.tarja?.enabled ?? false,
      showNotificationMessage: false,
      modalData: {
        id_colaboracao: "",
        dsc_nome_colaborador: "",
        dsc_nome_colaborador_old: "",
        dsc_texto_colaboracao: "",
        dsc_texto_colaboracao_old: "",
        cod_producao: "",
        url_avatar_colaborador: "",
        flg_sem_avatar: false,
        dsc_tipo_midia_colaboracao: "",
      },
      page: 1,
      currentAprovadasPage: 1,
      size: 5,
      pageModerada: 1,
      sizeModerada: 5,
      flg_favorita: false,
      filtros: "",
      filtro_texto: "",
      filtro_texto_moderada: "",
      filtro_texto_moderada_2: "",
      filtro_texto_moderada_3: "",
      isModalInserirColaboracaoVisible: false,
      timerAprovada: null,
      timerModerada: null,
      timerMosaico: null,
      flg_exibida: false,
      configsMosaico: [],
      diff: 0, // diff between old colabs number and new ones
      coluna_selecionada: null,
    };
  },
  beforeCreate() {
    const modoModeracao = Number(localStorage.getItem("@socialcam/modoModeracao"));
    if (modoModeracao === 0) {
      this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.dark;
      this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.light;
    }
  },
  async created() {
    this.clearToasts();

    await this.getProducoes({
      page: 1,
      filtro_texto: "",
      flg_ativo: "S",
      isAdmin: this.isAdm,
      dsc_login_usuario: this.username,
    });

    const selectedProducao = this.$store.state.producoes.selectedProducao;
    if (selectedProducao?.cod_producao) {
      this.cod_producao = selectedProducao.cod_producao;
    }
    this.isDark =
      localStorage.getItem("@socialcam/is_dark_theme") === "true" ? true : false;
    if (this.cod_producao) {
      this.getPastas({ cod_producao: this.cod_producao });

      await Promise.all([
        this.getColunaProducao(),
        this.getColaboracoesAprovadas({
          page: this.$store.state.colaboracoes_aprovadas.colaboracoes_aprovadas
            ? this.$store.state.colaboracoes_aprovadas.colaboracoes_aprovadas.currentPage
            : this.page,
          size: this.size,
          cod_producao: this.cod_producao,
          flg_favorita: this.flg_favorita,
          filtros: this.filtros,
          filtro_texto: this.filtro_texto,
          cod_pasta: this.cod_pasta,
          flg_exibida: this.flg_exibida,
        }),
        this.getColaboracoesModeradas({
          page: 1,
          size: this.size,
          cod_producao: this.cod_producao,
          num_coluna_telao: this.num_coluna_telao,
          filtro_texto_moderada: this.filtro_texto_moderada,
        }),
      ]);

      this.setCopyColaboracoesRecebidas(
        this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
      );
      this.getAllConfigsMosaico({ cod_producao: this.cod_producao });
      this.getPreferenciasMosaico({ cod_producao: this.cod_producao });
      this.updateTimers();
    }
  },
  async mounted() {
    this.filtro_texto_moderada =
      localStorage.getItem("@socialcam/filtro_texto_moderada") || "";
    this.filtro_texto_moderada_2 =
      localStorage.getItem("@socialcam/filtro_texto_moderada_2") || "";
    this.filtro_texto_moderada_3 =
      localStorage.getItem("@socialcam/filtro_texto_moderada_3") || "";
  },
  beforeMount() {
    this.setQueryParameters();
    this.flg_exibida = JSON.parse(
      localStorage.getItem("@socialcam/flg_exibida") || false
    );
    this.$store.commit("pastas/setIsPastaAtiva", JSON.parse(
      localStorage.getItem("@socialcam/isPastaAtiva") || false
    ));
    this.flg_favorita = JSON.parse(
      localStorage.getItem("@socialcam/flg_favorita") || false
    );
  },
  beforeDestroy() {
    clearInterval(this.timerAprovada);
    clearInterval(this.timerModerada);
    clearInterval(this.timerMosaico);
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas: "colaboracoes_aprovadas/getColaboracoesAprovadas",
      getColaboracoesModeradas: "colaboracoes_moderadas/getColaboracoesModeradas",
      changeIfFiltroIsActive: "colaboracoes_aprovadas/changeIfFiltroIsActive",
      changeCodProducao: "colaboracoes_aprovadas/changeCodProducao",
      getProducoes: "producoes/getProducoes",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
      getAllConfigsMosaico: "mosaico/getAllConfigsMosaico",
      getPreferenciasMosaico: "mosaico/getPreferenciasMosaico",
      getColunas: "colaboracoes_moderadas/getColunas",
      getColaboracoesFiltrosRedesSociais: "colaboracoes_aprovadas/getColaboracoesFiltrosRedesSociais",
      getPastas: "pastas/getPastas",
      setPageModerada: "colaboracoes_moderadas/setPageModerada",
    }),
    setQueryParameters() {
      if (!JSON.parse(localStorage.getItem("@socialcam/isPastaAtiva"))) {
        localStorage.setItem("@socialcam/isPastaAtiva", false);
      }
      if (!JSON.parse(localStorage.getItem("@socialcam/flg_exibida"))) {
        localStorage.setItem("@socialcam/flg_exibida", false);
      }
      if (!JSON.parse(localStorage.getItem("@socialcam/flg_favorita"))) {
        localStorage.setItem("@socialcam/flg_favorita", false);
      }
    },
    changeFlags({ flg_exibida, flg_favorita, pasta }) {
      this.flg_exibida = flg_exibida;
      this.flg_favorita = flg_favorita;
      this.$store.commit("pastas/setIsPastaAtiva", pasta);
      this.updateTimers();
    },
    clearToasts() {
      setTimeout(() => {
        this.$toast.clear();
      }, 60000 * 2.5);
    },
    changeTheme(e) {
      localStorage.setItem("@socialcam/is_dark_theme", e);
      this.$vuetify.theme.dark = e;
    },
    updateTimers() {
      clearInterval(this.timerAprovada);
      clearInterval(this.timerModerada);
      clearInterval(this.timerMosaico);


      this.timerAprovada = setInterval(async () => {
        const page = this.isPastaAtiva
          ? this.colaboracoes?.colaboracoes_em_pasta?.currentPage
          : this.flg_exibida
          ? this.colaboracoes?.colaboracoes_exibidas?.currentPage
          : this.flg_favorita
          ? this.colaboracoes?.colaboracoes_favoritas?.currentPage
          : this.colaboracoes?.colaboracoes_recebidas?.currentPage;
        await this.getColaboracoesAprovadas({
          page: page,
          size: this.size,
          cod_producao: this.cod_producao,
          flg_favorita: this.flg_favorita,
          filtros: this.filtros,
          filtro_texto: this.filtro_texto,
          flg_exibida: this.flg_exibida,
          cod_pasta: this.cod_pasta,
        });
        // Refresh filter sources to detect new social networks
        this.getColaboracoesFiltrosRedesSociais({ cod_producao: this.cod_producao });
        if (this.diff > 0 && this.$store.state.producoes.automaticUpdateOfColabs === 0) {
          const toastText =
            this.diff === 1
              ? `${this.diff} nova colaboração`
              : this.diff > 1
              ? `${this.diff} novas colaborações`
              : `${this.diff} novas colaborações`;
          const toastContent = {
            component: NotificacaoColaboracoes,
            props: {
              text: toastText,
              ButtonClickFunction: () => this.handleUpdateButton(),
            },
          };
          if (this.$store.state.moderacao.modoModeracao === 0) {
            this.$toast(toastContent, {
              id: "NOTIFY",
              maxToasts: 1,
              position: POSITION.BOTTOM_LEFT,
              timeout: 8000,
              // For the actual toast, including different toast types:
              toastClassName: "my-custom-toast-class",
              // For the toast body when using strings or a custom component as content
              bodyClassName: ["custom-class-1", "custom-class-2"],
            });
          }
        } else {
          this.setCopyColaboracoesRecebidas(
            this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
          );
        }
      }, 60000); // Chama a função a cada 1 minuto.

      this.timerModerada = setInterval(() => {
        const pageModerada =
          this.$store.state.colaboracoes_moderadas?.colaboracoes_moderadas[
            this.num_coluna_telao
          ].currentPage || 1;
        this.getColaboracoesModeradas({
          page: pageModerada,
          size: this.size,
          cod_producao: this.cod_producao,
          num_coluna_telao: this.num_coluna_telao,
        });
      }, 15000); // Chama a função a cada 15 segundos.

      this.timerMosaico = setInterval(() => {
        this.getAllConfigsMosaico({ cod_producao: this.cod_producao });
        this.getPreferenciasMosaico({ cod_producao: this.cod_producao });
      }, 15000);
    },

    async handleAprovadasPageChange() {
      await this.getColaboracoesAprovadas({
        page: this.page,
        size: 5,
        cod_producao: this.cod_producao,
        flg_favorita: this.flg_favorita,
        filtros: this.filtros,
        filtro_texto: this.filtro_texto,
        flg_exibida: this.flg_exibida,

        cod_pasta: this.cod_pasta,
      });
      this.setCopyColaboracoesRecebidas(
        this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
      );
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async handleModeradasPageChange() {
      await this.getColaboracoesModeradas({
        page: this.pageModerada,
        size: this.size,
        cod_producao: this.cod_producao,
        num_coluna_telao: this.num_coluna_telao,
        filtro_texto_moderada: this.filtro_texto_moderada,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    showModalInserirColaboracao() {
      this.isModalInserirColaboracaoVisible = true;
    },
    closeModalInserirColaboracao() {
      this.isModalInserirColaboracaoVisible = false;
    },
    showModal(data) {
      this.isModalVisible = true;
      this.modalData.id_colaboracao = data.id_colaboracao;
      this.modalData.dsc_nome_colaborador = data.dsc_nome_colaborador;
      this.modalData.dsc_nome_colaborador_old = data.dsc_nome_colaborador;
      this.modalData.dsc_texto_colaboracao = data.dsc_texto_colaboracao;
      this.modalData.dsc_texto_colaboracao_old = data.dsc_texto_colaboracao;
      this.modalData.cod_producao = data.cod_producao;
      this.modalData.url_avatar_colaborador = data.url_avatar_colaborador;
      this.modalData.flg_sem_avatar = data.flg_sem_avatar === "S" ? true : false;
      this.modalData.dsc_tipo_midia_colaboracao = data.dsc_tipo_midia_colaboracao;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    changeFavorita(flgFavorita) {
      this.flg_favorita = flgFavorita;
      if (flgFavorita) {
        this.currentAprovadasPage = this.page;
        this.page = 1;
      } else {
        this.page = this.currentAprovadasPage;
      }
    },
    async getColunaColaboracoesModerada(
      num_coluna_telao,
      page = this.pageModerada,
      filtro_texto_moderada
    ) {
      this.num_coluna_telao = num_coluna_telao;
      await this.getColaboracoesModeradas({
        num_coluna_telao,
        page,
        size: this.sizeModerada,
        cod_producao: this.cod_producao,
        filtro_texto_moderada,
      });
    },
    async getColunaProducao(forceRefetch = false) {
      const cached = this.$store.state.colaboracoes_moderadas.colunas_ativas;
      if (!forceRefetch && cached && cached.length > 0) {
        if (!this.coluna_selecionada) {
          this.coluna_selecionada = { ...cached[0], index: 0 };
        }
        return;
      }
      await this.getColunas({ cod_producao: this.cod_producao, flg_ativo: true }).then(
        (response) => {
          this.coluna_selecionada = { ...response[0], index: 0 };
        }
      );
    },
    changeColuna(num_coluna_telao, change_coluna_ativa_obj) {
      this.num_coluna_telao = num_coluna_telao;
      if (change_coluna_ativa_obj) {
        this.coluna_selecionada = { ...change_coluna_ativa_obj, index: 0 };
      }

      this.pageModerada = 1;
    },
    changeColunaSelecionada(coluna) {
      this.coluna_selecionada = { ...coluna, index: coluna.index };
    },
    abrirMosaico(tipoMosaico) {
      this.tipoMosaico = localStorage.setItem("@socialcam/tipo_mosaico", tipoMosaico);
      const mosaicoRoute = this.$router.resolve({ path: "/mosaico" });
      window.open(mosaicoRoute.href);
    },
    handleUpdateButton() {
      this.setCopyColaboracoesRecebidas(
        this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
      );
    },
  },
  computed: {
    ...mapGetters({
      dark_theme: "themes/getTheme",
      colaboracoes: "colaboracoes_aprovadas/colaboracoes",
      colaboracoesModeradas: "colaboracoes_moderadas/colaboracoes_moderadas",
      producoes: "producoes/getterProducoes",
      copyColaboracoesRecebidas: "colaboracoes_aprovadas/getCopyColaboracoesRecebidas",
      producao: "producoes/getterProducao",
      colunas_ativas: "colaboracoes_moderadas/getterColunasAtivas",
      cod_pasta: "pastas/getterCodPasta",
      isPastaAtiva: "pastas/getterIsPastaAtiva",
      isAdm: "users/isAdm",
      username: "users/username",
      pageModeradaState: "colaboracoes_moderadas/pageModerada",
    }),
  },
  watch: {
    pageModerada() {
      this.setPageModerada(this.pageModerada);
    },
    "$store.state.colaboracoes_moderadas.pageModerada"(newValue) {
      if (newValue && newValue !== this.pageModerada) {
        this.pageModerada = newValue;
      }
    },
    "$store.state.colaboracoes_aprovadas.copy_colaboracoes_recebidas"() {
      const recebidasStoreValue = this.$store.state.colaboracoes_aprovadas.colaboracoes
        .colaboracoes_recebidas;
      this.diff = this.copyColaboracoesRecebidas
        ? recebidasStoreValue.totalItems - this.copyColaboracoesRecebidas.totalItems
        : 0;
    },
    "$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas"() {
      const recebidasStoreValue = this.$store.state.colaboracoes_aprovadas.colaboracoes
        .colaboracoes_recebidas;
      this.diff = this.copyColaboracoesRecebidas
        ? recebidasStoreValue.totalItems - this.copyColaboracoesRecebidas.totalItems
        : 0;
    },
    "$store.state.producoes.selectedProducao": async function (newValue) {
      this.cod_producao = newValue.cod_producao;
      this.producaoUsesTarja = newValue.settings?.tarja?.enabled ?? false;
      (this.page = 1), (this.pageModerada = 1);
      localStorage.removeItem("@socialcam/tipo_mosaico");
      localStorage.removeItem("@socialcam/config_mosaico");
      let localFiltro = localStorage.getItem("@socialcam/filtros");
      // let localFlgFavorita = localStorage.getItem("@socialcam/flg_favorita");
      let localFiltroTexto = localStorage.getItem("@socialcam/filtro_texto");

      this.updateTimers();
      await Promise.all([
        this.getColunaProducao(true),
        this.getColaboracoesAprovadas({
          page: 1, size: 5, cod_producao: this.cod_producao,
          flg_favorita: true, filtros: localFiltro, filtro_texto: localFiltroTexto,
          flg_exibida: false, cod_pasta: 0,
        }),
        this.getColaboracoesAprovadas({
          page: 1, size: 5, cod_producao: this.cod_producao,
          flg_favorita: false, filtros: localFiltro, filtro_texto: localFiltroTexto,
          flg_exibida: false, cod_pasta: 0,
        }),
        this.getColaboracoesAprovadas({
          page: 1, size: 5, cod_producao: this.cod_producao,
          flg_favorita: false, filtros: localFiltro, filtro_texto: localFiltroTexto,
          flg_exibida: true, cod_pasta: 0,
        }),
        this.getColaboracoesModeradas({
          page: 1, size: this.size, cod_producao: this.cod_producao,
          num_coluna_telao: 1, filtro_texto_moderada: "",
        }),
        this.getColaboracoesModeradas({
          page: 1, size: this.size, cod_producao: this.cod_producao,
          num_coluna_telao: 2, filtro_texto_moderada: "",
        }),
        this.getColaboracoesModeradas({
          page: 1, size: this.size, cod_producao: this.cod_producao,
          num_coluna_telao: 3, filtro_texto_moderada: "",
        }),
      ]);

      this.setCopyColaboracoesRecebidas(
        this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas
      );
      this.getAllConfigsMosaico({ cod_producao: this.cod_producao });
      this.getPreferenciasMosaico({ cod_producao: this.cod_producao });

      this.getPastas({ cod_producao: this.cod_producao });
    },
  },
};
</script>

<style lang="scss" scoped>
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.rotate {
  animation: spin 2s linear infinite;
}

.view-options {
  gap: 1rem;

  .v-btn {
    border: solid 1px #9e9e9e;
    font-size: 0.875rem !important;
  }
}

.verTarjaBtn {
  border: 1px solid var(--v-border_default-base);

  strong {
    font-weight: 700 !important;
    font-size: 1rem;
  }
}

.labelProd {
  color: var(--v-text_primary-base);
}

.subMenu.Light {
  filter: drop-shadow(5px 5px 5px rgba(161, 161, 163, 0.5));
}

.subMenu {
  border-top: 1px solid rgba(161, 161, 163, 0.2);
  filter: drop-shadow(5px 5px 5px rgba(0, 0, 0, 0.5));

  background-color: var(--bg-secondary);

  .subMenuWrapper {
    max-width: 90rem;
    margin: 0 auto;
    display: flex;
    padding: 0.5rem;
    align-items: center;
    gap: 2rem;
    height: 6.5rem;

    button {
      color: var(--green-primary);
      border: none;
      background-color: transparent;

      strong {
        margin-right: 0.5rem;
      }
    }

    .combobox {
      label {
        color: var(--white);
      }

      select {
        margin-left: 1rem;
        background-color: var(--bg);
        border-radius: 0.5rem;
        width: 27.875rem;
        height: 2.5rem;
        border: none;
      }
    }
  }
}

.colaboracoesWrapper {
  margin-top: 2rem;

  .colaboacoesFlex {
    display: flex;
    max-width: 90rem;
    margin: 0 auto;
    gap: 2rem;
    justify-content: center;
  }
}
</style>
